import { CommonModule } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import {
  OAuthModule,
  OAuthModuleConfig,
  OAuthStorage,
} from 'angular-oauth2-oidc';
import { AuthService } from './auth.service';
import { ConfigService } from './config.service';
import { MaintenanceService } from './maintenance.service';
import { OauthModuleConfigService } from './oauth-module-config.service';

function storageFactory(): OAuthStorage {
  return localStorage;
}

export function oauthModuleConfigFactory(
  oauthModuleConfigService: OauthModuleConfigService,
) {
  return oauthModuleConfigService.getOauthModuleConfig();
}

@NgModule({
  declarations: [],
  imports: [CommonModule, OAuthModule.forRoot()],
  providers: [
    AuthService,
    ConfigService,
    MaintenanceService,
    OauthModuleConfigService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        { provide: OAuthStorage, useFactory: storageFactory },
        {
          provide: OAuthModuleConfig,
          useFactory: oauthModuleConfigFactory,
          deps: [OauthModuleConfigService],
        },
      ],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only',
      );
    }
  }
}
